import { render, staticRenderFns } from "./objinput_dz.vue?vue&type=template&id=7c5795b1&scoped=true"
import script from "./objinput_dz.vue?vue&type=script&lang=js"
export * from "./objinput_dz.vue?vue&type=script&lang=js"
import style0 from "./objinput_dz.vue?vue&type=style&index=0&id=7c5795b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5795b1",
  null
  
)

export default component.exports